/*
 * Copyright (c) 2020. American Express Company
 */

import React from 'react';
import ReactDOM from 'react-dom';

import './index.scss';
import 'src/styles/svg.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'src/bw/extensions/number.extensions';

const axe = require('@axe-core/react');

ReactDOM.render(<App />, document.getElementById('root'));

if (process.env.REACT_APP_AXE_REACT_ENABLED) axe(React, ReactDOM, 1000);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
